export const ProductName = 'CorpTube';

export const mapToYouboraConfig = (config, playerId, videoId, visitorId) => {
  const youboraConfig = config.playerDefinition.analytics?.youbora;

  if (!youboraConfig || !youboraConfig.enabled) return;

  return {
    accountCode: process.env.REACT_APP_NPAW_ACCOUNT_CODE || '',
    host: youboraConfig.url,
    'user.name': visitorId,
    'content.id': videoId,
    'content.title': config.videoMetaData?.title,
    'content.isLive': false,
    'content.channel': getChannelName(config),
    'content.customDimension.1': config.videoMetaData?.hashedVideoManagerId,
    'content.customDimension.2': playerId,
    'content.customDimension.3': getChannelId(config),
    'content.customDimension.4': document.location.href,
    'content.customDimension.5': getReferrerInfo(),
    'content.customDimension.6': config.videoMetaData?.groupId,
    'content.customDimension.7': getAccountId(config),
    'content.customDimension.8': ProductName,
  };
};

function getChannelName(playerConfig) {
  return playerConfig.videoMetaData?.channelName
    ? playerConfig.videoMetaData.channelName
    : 'Not linked to channel / Channel information not available';
}

function getChannelId(playerConfig) {
  if (!playerConfig.channelId || playerConfig.channelId === '00000' || playerConfig.channelId === '0') {
    return 'Not linked to channel / Channel information not available';
  }
  return playerConfig.channelId;
}

function getReferrerInfo() {
  return document.referrer ? document.referrer : 'Direct access without referrer / Referrer information not available';
}

function getAccountId(playerConfig) {
  return playerConfig.videoMetaData?.accountId
    ? playerConfig.videoMetaData.accountId
    : 'VideoManager Pro Account ID not available';
}
